import {
  AdditionalDomainsType,
  ImmovablePropertyType,
  MovablePropertyType,
  Who,
} from '../types';

export interface AppConfig {
  broker_uid: string;
  logoSrc: string;
  heroImgSrc: string;
  resultImg: string;
  desktopImg: string;
  baseName: string;
  theme: THEME;
  helpNeeded: boolean;
  scenarios: string[];
  additionalDomains: AdditionalDomainsType['name'][];
  movableProperties: MovablePropertyType[];
  immovableProperties: ImmovablePropertyType[];
  whoFields: any[];
  debtFields: any[];
  showResultGraph: boolean;
  showLeadConfidence: boolean;
}

export enum THEME {
  MYFARO = 'MYFARO',
  BSURE = 'BSURE',
}
